import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { PrinterOutlined } from "@ant-design/icons";
import Button from "../../components/button";
import { InputLabelSelect } from "../../components/inputLabel";
import PageTitle from "../../components/pageTitle";
import extratoRepasseExternoActions from "../../redux/extratoRepasseExterno/actions";
import { StoreState } from "../../redux/reduxTypes";
import {
  ExtratoRepasseExternoState,
  UserSession,
} from "../../types/state.types";
import {
  AreaCooperado,
  AreaData,
  AreaInfo,
  ColunasDescricao,
  ColunasImpostos,
  ColunasLiquido,
  ColunasTotal,
  ContainerPagina,
  DiscriminacaoVerba,
  FormFiltros,
  InfoCooperativa,
  LinhasTabela,
  TabelaConteudo,
} from "./styled";

import { getSessionConfig } from "../../utils/session-helper";
import { formatData, formatMoney } from "../../utils/functions-helper";
import IndicadorSemDados from "../../components/indicadorSemDados";
import { useNavigate } from "react-router-dom";
import routes from "../../routes/routes.path";

function ExtratoRepasseExterno() {
  const dispatch = useDispatch();
  const {
    filtros,
    listaCompetencias,
    listaFolhas,
    listaLotacoes,
    admissao,
    categoria,
    dadosExtrato,
    requisitado,
    loading,
  } = useSelector<StoreState, ExtratoRepasseExternoState>(
    (state) => state.extratoRepasseExternoState
  );
  const userData = useSelector<StoreState, UserSession | undefined>(
    (state) => state.loginState.userData
  );

  const [totalProventos, settotalProventos] = useState(0);
  const [totalDescontos, settotalDescontos] = useState(0);
  const [liquidoReceber, setliquidoReceber] = useState(0);
  const [baseCalculoINSS, setbaseCalculoINSS] = useState(0);
  const [baseCalculoIR, setbaseCalculoIR] = useState(0);
  const [cooperativaSessionData] = useState(getSessionConfig());
  const navigate = useNavigate();

  const setFiltros = (value: {}) => {
    dispatch(
      extratoRepasseExternoActions.setFiltros({
        ...filtros,
        ...value,
      })
    );
  };

  const buscarLotacoes = useCallback(
    async (competencia: string) => {
      await dispatch(extratoRepasseExternoActions.buscarLotacoes(competencia));
    },
    [dispatch]
  );

  const buscarFolhas = useCallback(
    async (lotacaoId?: string) => {
      if (lotacaoId) {
        await dispatch(
          extratoRepasseExternoActions.buscarFolhas(
            lotacaoId,
            filtros.competencia
          )
        );
      }
    },
    [dispatch, filtros.competencia]
  );

  const pesquisarExtratoFolha = useCallback(async () => {
    await dispatch(
      extratoRepasseExternoActions.buscarExtratoFolha(
        filtros.competencia,
        filtros.lotacaoId ?? "0",
        filtros.folha ?? "0"
      )
    );
  }, [dispatch, filtros.lotacaoId, filtros.folha, filtros.competencia]);
  /* 
  const gerarPDF = useCallback(async () => {
    const tabelaER = document.getElementById("conteudoParaPdf");

    if (tabelaER === null) {
      return message.error('Erro ao gerar PDF');
    }
    downloadPDFPaginaUnica(`Extrato_Repasse_${getSession().userData?.CPF}`, tabelaER);
  }, []);
 */
  useEffect(() => {
    if (!requisitado) {
      dispatch(extratoRepasseExternoActions.inicializaEstado());
    }
  }, [dispatch, requisitado]);

  useEffect(() => {
    if (dadosExtrato && dadosExtrato.length > 0) {
      dadosExtrato?.forEach((extrato) => {
        switch (extrato.ID_VerbaFolhaExterna) {
          case "2":
            settotalProventos(extrato.ValorVerba);
            break;
          case "3":
            settotalDescontos(extrato.ValorVerba);
            break;
          case "602":
            setbaseCalculoINSS(extrato.ValorVerba);
            break;
          case "603":
            setbaseCalculoIR(extrato.ValorVerba);
            break;
          case "4":
            setliquidoReceber(extrato.ValorVerba);
            break;
          default:
            break;
        }
      });
    }
  }, [dadosExtrato]);

  const irParaImpressao = useCallback(() => {
    navigate(routes.ExtratoRepasseExternoImpressao);
  }, [navigate]);

  return (
    <ContainerPagina>
      <PageTitle titulo="Extrato de Repasse Externo" />

      <FormFiltros>
        <div className="filtros">
          <InputLabelSelect
            labelText="Competência"
            labelId="competencia"
            value={filtros.competencia}
            onChange={(value) => {
              setFiltros({
                competencia: value,
              });

              if (value !== "0" && !isNaN(parseInt(value))) {
                buscarLotacoes(value);
              }
            }}
            options={listaCompetencias.map((item) => {
              return {
                label: item.CompetenciaList,
                value: item.Competencia.toString(),
              };
            })}
            required
          />

          <InputLabelSelect
            labelText="Lotação"
            labelId="lotacaoId"
            options={listaLotacoes.map((item) => {
              return { label: item.Nome, value: item.ID.toString() };
            })}
            value={filtros.lotacaoId}
            onChange={(value) => {
              setFiltros({
                lotacaoId: value,
              });

              if (value !== "0" && !isNaN(parseInt(value))) {
                buscarFolhas(value);
              }
            }}
            required
          />

          <InputLabelSelect
            labelText="Data de Pagamento"
            labelId="folha"
            options={listaFolhas.map((item) => {
              return {
                label: formatData(item.DataPagamento),
                value: item.ID_ControleFolha.toString(),
              };
            })}
            value={filtros.folha}
            onChange={(value) => {
              setFiltros({
                folha: value,
              });
            }}
          />
        </div>

        <div className="botoes">
          <Button
            onClick={(event) => {
              event.preventDefault();
              pesquisarExtratoFolha();
            }}
            style={{ marginRight: "15px" }}
            primary
          >
            Consultar
          </Button>

          {!loading && dadosExtrato && dadosExtrato.length > 0 ? (
            <Button
              primary
              onClick={(e) => {
                e.preventDefault();
                irParaImpressao();
              }}
            >
              <PrinterOutlined style={{ marginRight: "10px" }} />
              Imprimir
            </Button>
          ) : (
            <></>
          )}
          {/* <Button
          onClick={event => {
            event.preventDefault();
            gerarPDF();
          }}
          primary
        >
          <DownloadOutlined style={{ marginRight: '10px' }} />
          Gerar PDF
        </Button> */}
        </div>
      </FormFiltros>

      <div className="tabela">
        {dadosExtrato && dadosExtrato.length > 0 ? (
          <TabelaConteudo id="conteudoParaPdf">
            <tbody>
              <tr>
                <td>
                  <header>
                    <AreaData>
                      <tbody>
                        <tr>
                          <td>
                            {new Date().toLocaleDateString("pt-Br", {
                              weekday: "long",
                              year: "numeric",
                              month: "long",
                              day: "numeric",
                            })}
                          </td>
                        </tr>
                      </tbody>
                    </AreaData>

                    <AreaInfo>
                      <tbody>
                        <tr>
                          <td>
                            <img
                              src={
                                "data:image/png;base64, " +
                                cooperativaSessionData.Logo
                              }
                              alt={`Logotipo - ${
                                cooperativaSessionData.Nome?.split(" ")[0]
                              }`}
                            />
                          </td>
                          <td className="containerInfos">
                            <span>
                              <strong>EXTRATO DE REPASSE</strong>
                              <br />
                            </span>
                          </td>
                        </tr>
                      </tbody>
                    </AreaInfo>

                    <InfoCooperativa>
                      <tbody>
                        <tr>
                          <td>
                            COOPERATIVA
                            <strong>{cooperativaSessionData.Nome}</strong>
                          </td>

                          <td>
                            CNPJ
                            <strong>{cooperativaSessionData.CNPJ}</strong>
                          </td>

                          <td>
                            ADMISSÃO
                            <strong>
                              {admissao
                                ? admissao
                                    .split("T")[0]
                                    .split("-")
                                    .reverse()
                                    .join("/")
                                : " -- "}
                            </strong>
                          </td>

                          <td>
                            COMPETÊNCIA
                            <strong>{dadosExtrato[0].CompetenciaList}</strong>
                          </td>
                        </tr>
                      </tbody>
                    </InfoCooperativa>

                    <AreaCooperado>
                      <tbody>
                        <tr>
                          <td>
                            COOPERADO
                            <strong>
                              {userData
                                ? `${userData.Matricula} - ${userData.Nome}`
                                : " -- "}
                            </strong>
                          </td>

                          <td>
                            CARGO
                            <strong>{categoria ?? " -- "}</strong>
                          </td>

                          <td>
                            LOTAÇÃO
                            <strong>{dadosExtrato[0].NomeLotacao}</strong>
                          </td>
                        </tr>
                      </tbody>
                    </AreaCooperado>

                    <DiscriminacaoVerba>
                      Discriminacao Das Verbas
                    </DiscriminacaoVerba>
                  </header>

                  <ColunasDescricao>
                    <tbody>
                      <tr>
                        <td>COD.</td>
                        <td>DESCRIÇÃO</td>
                        <td>REFERÊNCIA</td>
                        <td>PROVENTO</td>
                        <td>DESCONTO</td>
                      </tr>
                    </tbody>
                  </ColunasDescricao>
                  <main>
                    <LinhasTabela>
                      <tbody>
                        {dadosExtrato ? (
                          dadosExtrato
                            .filter((extrato) => {
                              return (
                                extrato.ID_TipoVerbaFolha === 1 ||
                                extrato.ID_TipoVerbaFolha === 2 ||
                                extrato.ID_TipoVerbaFolha === -1
                              );
                            })
                            .map((extrato, i) => {
                              return (
                                <tr key={i}>
                                  <td>{extrato.ID_VerbaFolhaExterna}</td>

                                  <td
                                    style={{
                                      textAlign: "left",
                                      paddingLeft: "8px",
                                    }}
                                  >
                                    {extrato.Verba}
                                  </td>

                                  <td>{extrato.Referencia}</td>

                                  <td>
                                    {extrato.ID_TipoVerbaFolha &&
                                    extrato.ID_TipoVerbaFolha === 1
                                      ? formatMoney(extrato.ValorVerba)
                                      : ""}
                                  </td>

                                  <td>
                                    {extrato.ID_TipoVerbaFolha &&
                                    extrato.ID_TipoVerbaFolha === 2
                                      ? formatMoney(extrato.ValorVerba)
                                      : ""}
                                  </td>
                                </tr>
                              );
                            })
                        ) : (
                          <></>
                        )}
                        {[10, 11, 12, 13, 14].map((i) => (
                          <tr key={i}>
                            <td></td>

                            <td></td>

                            <td></td>

                            <td></td>

                            <td></td>
                          </tr>
                        ))}
                      </tbody>
                    </LinhasTabela>

                    <ColunasTotal>
                      <tbody>
                        <tr>
                          <td> </td>
                          <td>
                            TOTAL PROVENTOS
                            <strong>{formatMoney(totalProventos)}</strong>
                          </td>
                          <td>
                            TOTAL DESCONTOS
                            <strong>{formatMoney(totalDescontos)}</strong>
                          </td>
                        </tr>
                      </tbody>
                    </ColunasTotal>

                    <ColunasLiquido>
                      <tbody>
                        <tr>
                          <td> </td>
                          <td id="valorLiquido">
                            LIQUIDO A RECEBER
                            <strong>{formatMoney(liquidoReceber)}</strong>
                          </td>
                        </tr>
                      </tbody>
                    </ColunasLiquido>

                    <ColunasImpostos>
                      <tbody>
                        <tr>
                          <td> </td>
                          <td>
                            BASE DE CALCULO DO INSS
                            <strong>{formatMoney(baseCalculoINSS)}</strong>
                          </td>
                          <td>
                            BASE DE CALCULO DO IRRF
                            <strong>{formatMoney(baseCalculoIR)}</strong>
                          </td>
                        </tr>
                      </tbody>
                    </ColunasImpostos>
                  </main>
                </td>
              </tr>
            </tbody>
          </TabelaConteudo>
        ) : (
          <IndicadorSemDados />
        )}
      </div>
    </ContainerPagina>
  );
}

export default ExtratoRepasseExterno;
